<template>
  <div class="echart-box-cla">
    <div class="chart_title_cla">
      <div class="title-bg-cla"></div>
      <div class="title-Text-cla">{{ $t('dashboard.addDeviceBar') }}</div>
    </div>
    <div id="devAddBar" class="echart-cla"></div>
  </div>
</template>

<script>
import { devNewAddedTotal } from '@/services/dashboardApi.js'
import { getOptionConfig } from './newDevChar.js'
var echarts = require('echarts')
export default {
  data() {
    return {
      barChart: null,
      barData: [],
      category: [],
      timeout: null,
      intervalnewAdd: null
    }
  },
  mounted() {
    let _this = this
    this.getData()
    window.addEventListener('resize', this.resizeChart, true)
    this.intervalnewAdd = setInterval(() => {
      _this.getData()
    }, 10000)
  },
  beforeDestroy() {
    this.barChart.clear()
    this.barChart.dispose()
    window.removeEventListener('resize', this.resizeChart, true)
    if (this.intervalnewAdd) {
      clearInterval(this.intervalnewAdd)
    }
  },
  methods: {
    resizeChart() {
      if (this.barChart) {
        this.debounce(this.barChart.resize, 200)
      }
    },
    debounce(func, wait) {
      let context = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    },
    getOption() {
      let lang = {
        title: this.$t('dashboard.addDeviceBar'),
        name: this.$t('dashboard.addDevice')
      }
      let option = getOptionConfig(this.barData, this.category, lang)
      this.renderChart(option)
    },
    renderChart(option) {
      if (!this.barChart) {
        this.barChart = echarts.init(document.getElementById('devAddBar'))
      }
      this.barChart.setOption(option, true)
    },
    getData() {
      devNewAddedTotal().then((data) => {
        if (data.code === '00000000') {
          let result = data.payload.data
          this.barData = result.value.reverse()
          this.category = result.key.reverse()
          this.getOption()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/dashboard/newAddedTotal/newDevChar.vue